import {
    buttonWrapper,
    logoWrapper,
    ssoError,
    ssoErrorInner,
} from './styles/LoginView'
import Button from 'components/Button/Button'
import {EmbedErrorType} from 'embed/types/errorTypes'
import {EmbedEvent} from 'embed/types/events'
import {ExclamationIcon} from 'components/Icon'
import {InfoMessage} from 'components/InfoMessage'
import Logo from 'components/Logo/Logo'
import React from 'react'
import {config} from 'embed/listeners'
import {navigation} from '../../navigation'
import {styled} from 'stitches/config'
import {useSendToParent} from 'embed/utils/event'
import {useTranslation} from 'react-i18next'


const StyledSsoError = styled('div', ssoError)
const StyledSsoErrorInner = styled('div', ssoErrorInner)
const StyledLogoWrapper = styled('div', logoWrapper)
const StyledButtonWrapper = styled('div', buttonWrapper)


const LoginViewSsoError = ({ssoErrorType}: {ssoErrorType?: string}): React.ReactElement => {
    const {t} = useTranslation()
    const sendToParent = useSendToParent()

    const onRetry = (): void => {
        // Clear the ssoError route param so Login restarts the SSO flow.
        navigation.replace('Login')
    }

    React.useEffect(() => {
        sendToParent({
            error_type: EmbedErrorType.SSOAuthError,
            error_type_details: ssoErrorType,
            event: EmbedEvent.Error,
            targetOrigin: config.get('targetOrigin') || '',
        })
    }, [])

    return (
        <StyledSsoError>
            <StyledSsoErrorInner>
                <StyledLogoWrapper>
                    <Logo />
                </StyledLogoWrapper>
                <InfoMessage icon={ExclamationIcon} infoHeader={t('Authentication failed')} message={t('SSO login failed. Please try again.')} variant='error' />
                <StyledButtonWrapper>
                    <Button color='filled' onPress={onRetry} size='large' text={t('Retry SSO Login')} />
                </StyledButtonWrapper>
            </StyledSsoErrorInner>
        </StyledSsoError>
    )
}

LoginViewSsoError.defaultProps = {ssoErrorType: ''}

export default LoginViewSsoError
